import styled from '@emotion/styled'
import { useField } from 'formik'
import React from 'react'
import PhoneInput from 'react-phone-number-input'
import countryData from 'react-phone-number-input/locale/en.json'
import 'react-phone-number-input/style.css'

const telInputCountries = Object.keys(countryData)

const userCountryCode = (countryCode) => {
  if (typeof countryCode !== 'string') return undefined
  return telInputCountries.includes(countryCode) ? countryCode : undefined
}

const CustomTelField = ({ detectedCountryCode, ...passthrough }) => {
  const country = userCountryCode(detectedCountryCode)
  const [field] = useField(passthrough)

  const onChange = (val) => field.onChange(field.name)(val || '')
  const onBlur = () => field.onBlur(field.name)

  return (
    <StyleWrapper>
      <PhoneInput
        international
        id={passthrough.id}
        name={field.name}
        required={passthrough.required}
        value={field.value}
        onChange={onChange}
        onBlur={onBlur}
        defaultCountry={country}
      />
    </StyleWrapper>
  )
}

export default CustomTelField

const StyleWrapper = styled.div`
  .PhoneInput {
    --PhoneInput-color--focus: ${(p) => p.theme.colors.secondary};
    --PhoneInputCountrySelectArrow-color: ${(p) => p.theme.colors.primary};
    --PhoneInputCountrySelectArrow-color--focus: ${(p) =>
      p.theme.colors.secondary};
    --PhoneInputCountrySelectArrow-opacity: 1;

    position: relative;
    width: 100%;

    .PhoneInputInput {
      padding-left: 60px;
    }
    .PhoneInputCountry {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;

      padding-left: 12px;
      padding-right: 2px;
    }

    .PhoneInputCountryIcon--border {
      box-shadow: none !important;

      img {
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
      }
    }
  }
`
